import React from "react";
import Page from "./Page";
import { FiUser, FiMail, FiPhone, FiBriefcase, FiCalendar, FiGlobe, FiLinkedin, FiAward, FiUsers, FiUserCheck } from "react-icons/fi";

export const peopleColumns = [
  {
    accessor: "selection",
    massSelection: true,
    width: 20,
    Header: "",
  },
  {
    Header: "Status",
    accessor: "status",
    width: 120,
    DropdownOptions: [
      "New",
      "Contacted",
      "Refused Appointment",
      "Scheduled",
      "No Show",
      "Not Interested",
      "Qualified",
      "Proposal Sent",
      "Awaiting Info",
      "Grant Writing",
      "Application Sent",
      "Grant Awarded",
      "Grant Rejected",
      "Closed Won",
      "Closed Lost",
    ],
    dropdownBackgroundColor: (value) => {
      switch (value) {
        case "New":
          return "#3498db";
        case "Contacted":
          return "#2ecc71";
        case "Refused Appointment":
          return "#e74c3c";
        case "Scheduled":
          return "#7fd6ff";
        case "No Show":
          return "#ffad2e";
        case "Not Interested":
          return "#e74c3c";
        case "Qualified":
          return "#f1c40f";
        case "Proposal Sent":
          return "#9b59b6";
        case "Awaiting Info":
          return "#ffad2e";
        case "Grant Writing":
        case "Closed Won":
          return "#27ae60";
        case "Closed Lost":
          return "#e74c3c";
        default:
          return "#fff";
      }
    },
  },
  {
    Header: "VIP",
    accessor: "vip",
    width: 25,
    Cell: ({ value, row, updateCell }) => (
      <input
        type="checkbox"
        checked={!!value}
        onChange={(e) =>
          updateCell(row.original.id, "vip", e.target.checked)
        }
      />
    ),
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiUser />
        <span>Name</span>
      </div>
    ),
    accessor: "name",
    width: 200,
    autocomplete: true,
    buttonOnHover: {
      label: "↗",
      title: "View Details",
      onClick: (rowData) => {
      },
    },
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiBriefcase />
        <span>Company</span>
      </div>
    ),
    accessor: "company",
    width: 375,
    autocomplete: true,
    buttonOnHover: {
      label: "↗",
      title: "View Company Details",
      onClick: (rowData) => {
      },
    },
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiBriefcase />
        <span>Source</span>
      </div>
    ),
    accessor: "source",
    width: 150,
    autocomplete: true,
  },

  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiMail />
        <span>Email</span>
      </div>
    ),
    accessor: "email",
    width: 150,
    autocomplete: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiPhone />
        <span>Phone</span>
      </div>
    ),
    accessor: "phone",
    width: 150,
    autocomplete: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiCalendar />
        <span>Last Contact</span>
      </div>
    ),
    accessor: "last_contacted",
    width: 135,
    datePicker: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiCalendar />
        <span>Follow Up</span>
      </div>
    ),
    accessor: "follow_up_date",
    width: 135,
    datePicker: true,
  },
  // Old single-user assignment field (hidden but still in database)
  // Uncomment below to show the old "Assigned" column
  // {
  //   Header: (
  //     <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
  //       <FiUserCheck />
  //       <span>Assigned (Legacy)</span>
  //     </div>
  //   ),
  //   accessor: "assigned_to",
  //   chipDropdown: true,
  //   width: 150,
  //   chipDropdownOptions: [], 
  //   chipDropdownValueField: "id",
  //   chipDropdownDisplay: (user) =>
  //     `${user.first_name} ${user.last_name}`.trim(),
  //   chipDropdownChipColor: (row) =>
  //     row.active === "n" ? "#F08080" : row.chip_color || "#e0e0e0",
  // },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiUserCheck />
        <span>Primary Users</span>
      </div>
    ),
    accessor: "assignments.primary",
    width: 180,
    clickable: true,
    assignmentType: "primary",
    Cell: ({ row }) => {
      const primaryAssignments = row.original?.assignments?.primary || [];
      const firstAssignment = primaryAssignments[0];
      const remainingCount = primaryAssignments.length - 1;
      
      return (
        <div 
          style={{ 
            display: "flex", 
            flexWrap: "nowrap",
            gap: "4px",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            minHeight: "28px",
            alignItems: "center",
            transition: "background 0.2s ease",
            overflow: "hidden"
          }}
          className="assignment-cell"
          title={primaryAssignments.length > 0 
            ? `${primaryAssignments.map(a => `${a.first_name} ${a.last_name}`).join(', ')}` 
            : "Click to assign primary users"}
        >
          {primaryAssignments.length === 0 ? (
            <span style={{ color: "#999", fontSize: "12px" }}>Click to assign</span>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: firstAssignment.active === "n" ? "#F08080" : (firstAssignment.chip_color || "#e0e0e0"),
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                {firstAssignment.first_name} {firstAssignment.last_name}
              </div>
              {remainingCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#e0e0e0",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#666",
                    whiteSpace: "nowrap",
                  }}
                >
                  +{remainingCount}
                </div>
              )}
            </>
          )}
        </div>
      );
    },
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiUsers />
        <span>Secondary Users</span>
      </div>
    ),
    accessor: "assignments.secondary",
    width: 180,
    clickable: true,
    assignmentType: "secondary",
    Cell: ({ row }) => {
      const secondaryAssignments = row.original?.assignments?.secondary || [];
      const firstAssignment = secondaryAssignments[0];
      const remainingCount = secondaryAssignments.length - 1;
      
      return (
        <div 
          style={{ 
            display: "flex", 
            flexWrap: "nowrap",
            gap: "4px",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            minHeight: "28px",
            alignItems: "center",
            transition: "background 0.2s ease",
            overflow: "hidden"
          }}
          className="assignment-cell"
          title={secondaryAssignments.length > 0 
            ? `${secondaryAssignments.map(a => `${a.first_name} ${a.last_name}`).join(', ')}` 
            : "Click to assign secondary users"}
        >
          {secondaryAssignments.length === 0 ? (
            <span style={{ color: "#999", fontSize: "12px" }}>Click to assign</span>
          ) : (
            <>
              <div
                style={{
                  backgroundColor: firstAssignment.active === "n" ? "#F08080" : (firstAssignment.chip_color || "#e0e0e0"),
                  padding: "4px 8px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                {firstAssignment.first_name} {firstAssignment.last_name}
              </div>
              {remainingCount > 0 && (
                <div
                  style={{
                    backgroundColor: "#e0e0e0",
                    padding: "4px 8px",
                    borderRadius: "12px",
                    fontSize: "12px",
                    fontWeight: "600",
                    color: "#666",
                    whiteSpace: "nowrap",
                  }}
                >
                  +{remainingCount}
                </div>
              )}
            </>
          )}
        </div>
      );
    },
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiCalendar />
        <span>State</span>
      </div>
    ),
    accessor: "state",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiMail />
        <span>Secondary Email</span>
      </div>
    ),
    accessor: "secondary_email",
    width: 150,
    autocomplete: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiPhone />
        <span>Secondary Phone</span>
      </div>
    ),
    accessor: "secondary_phone",
    width: 150,
    autocomplete: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiGlobe />
        <span>Domain</span>
      </div>
    ),
    accessor: "domain",
    width: 150,
    autocomplete: true,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiLinkedin />
        <span>LinkedIn</span>
      </div>
    ),
    accessor: "linkedin",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiAward />
        <span>Role/Title</span>
      </div>
    ),
    accessor: "role_title",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiUsers />
        <span>Department</span>
      </div>
    ),
    accessor: "department",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiLinkedin />
        <span>LinkedIn Bio</span>
      </div>
    ),
    accessor: "linkedin_bio",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiLinkedin />
        <span>More Linkedin Info</span>
      </div>
    ),
    accessor: "more_linkedin_info",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiMail />
        <span>Email Draft</span>
      </div>
    ),
    accessor: "custom_email_draft",
    width: 150,
  },
  {
    Header: (
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <FiPhone />
        <span>VM Script</span>
      </div>
    ),
    accessor: "cold_call_script_voicemail",
    width: 150,
  },

];

const People = (props) => {
  return (
    <Page
      tableName="people"
      title="People"
      columns={peopleColumns}
      {...props}
    />
  );
};

export default People;
